import React from 'react'
import Image from 'components/Common/Image'

export const StepsHowItWorks = [
  {
    image: <Image id="waave-icon1" format="svg" height="60rem"/>,
    title: 'Pay By Bank:',
    description: 'Select Waave and Pay instantly from your bank',
  },
  {
    image: <Image id="waave-icon2" format="svg" height="60rem"/>,
    title: 'Fast Process:',
    description: 'Checkout without any need to remember your credit card or CCV numbers',
  },
  {
    image: <Image id="waave-icon3" format="svg" height="60rem"/>,
    title: 'Safe & Secure:',
    description: 'Approve how you pay and who you trust, with safeguards for every transaction',
  },
]

export function getStepsBuyNow() {
  return [
    {
      title: '1',
      description: 'Browse your favourite escapes',
    },
    {
      title: '2',
      description: 'Select Waave Pay by Bank at checkout',
    },
    {
      title: '3',
      description: 'Connect your bank account & finalise your purchase',
    },
  ]
}

export function getTermsAndConditionsUrlLink(currency: string) {
  switch (currency) {
    case 'AUD':
      return 'https://luxuryescapes.com/au/promotions'
    default:
      return 'https://luxuryescapes.com/au/promotions'
  }
}

export function getTermsOfUseLink(currency: string) {
  switch (currency) {
    case 'AUD':
      return 'https://www.waave.com/legal/user-agreement/'
    default:
      return 'https://www.waave.com/legal/user-agreement/'
  }
}
